import { ReactNode } from 'react';
import { useHistoryTreeWrite } from './history-tree-store';

export type HistoryTreeWriteProps = {
  children?: ReactNode;
  index?: boolean;
};
export const HistoryTreeWrite = ({
  children,
  index = false,
}: HistoryTreeWriteProps) => {
  useHistoryTreeWrite(index);
  return children;
};
